export default {
  methods: {
    getAlignClassName(align) {
      return `align-${align}`
    }
  }
}
